import { IconButton, TableCell, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getLocalesState } from '../../../selectors';

export function mapStateToProps(state) {
  const { saving } = getLocalesState(state);
  return {
    isSaving: saving
  };
}

export default function iconButtonCellFactory({ getButtonProps, getAction }) {
  class IconButtonCell extends PureComponent {
    static propTypes = {
      dispatch: PropTypes.func.isRequired,
      isSaving: PropTypes.bool.isRequired
    };

    handleClick = () => {
      this.props.dispatch(getAction(this.props));
    };

    render() {
      const { isSaving } = this.props;
      const buttonProps = getButtonProps(this.props);
      const { title } = buttonProps;
      const iconButton = (
        <IconButton {...buttonProps} disabled={isSaving} onClick={this.handleClick} size="small" disableRipple />
      );
      const cellContents = title ? <Tooltip title={title}>{iconButton}</Tooltip> : iconButton;
      return <TableCell>{cellContents}</TableCell>;
    }
  }

  return connect(mapStateToProps)(IconButtonCell);
}
